/**
 * Module-level store for contacts-sync (Google / iCloud) progress.
 *
 * Lives outside React so an in-flight sync keeps running — and stays visible —
 * even when the user navigates away from the Client Access page and comes back.
 * The HTTP request is fired here (not in the component), so unmounting the page
 * never cancels or "forgets" the sync.
 */
import { toast } from 'react-toastify';
import api from './axiosConfig';

let state = { google: false, apple: false };
const listeners = new Set();

function emit(event) {
  const snapshot = { ...state };
  listeners.forEach((fn) => fn(snapshot, event));
}

export function getSyncState() {
  return { ...state };
}

export function isSyncing(provider) {
  return !!state[provider];
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/**
 * Start a sync for 'google' | 'apple'. No-op if one is already running for that
 * provider. Resolves when done. Emits state changes to all subscribers and a
 * final { provider, done: true, ok, data } event on completion.
 */
export async function startSync(provider) {
  if (state[provider]) return;
  state = { ...state, [provider]: true };
  emit(null);

  let ok = false;
  let payload = null;
  try {
    const { data } = await api.post(`/backoffice/contacts-sync/${provider}/sync`);
    if (data.success) {
      toast.success(`تمت المزامنة — ${data.count} جهة اتصال`);
      ok = true;
      payload = data;
    } else {
      toast.error(data.message || 'خطأ في المزامنة');
    }
  } catch (err) {
    toast.error(err.response?.data?.message || 'خطأ في المزامنة');
  } finally {
    state = { ...state, [provider]: false };
    emit({ provider, done: true, ok, data: payload });
  }
}
